module.exports = __webpack_public_path__ + "static/img/basketball.b34d3c3.jpg";